// extracted by mini-css-extract-plugin
export default {"uparrow":"arrow_uparrow__AKQ5-","downarrow":"arrow_downarrow__FIB0e"};